import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import config from '../../config';
import request from 'superagent';

export function* getMedals() {
    yield* takeEvery("MEDALS/FETCH", function* (action) {
        try {
            const result = yield call(({ id }) => {
                console.log('saga')
                return request.get(`${config.apiEndpoint}/api/cs/v2/medals${id ? `/${id}` : ''}`)
                    .set('Authorization', `Bearer ${config.apiKey}`)
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { medals, medal } = result;                
                if (action.id) {
                    yield put({ type: 'MEDAL/SET', medal });
                } else {
                    localStorage.setItem('CS.MEDALS', JSON.stringify(medals));
                    yield put({ type: 'MEDALS/SET', medals });
                }
            } else {
                yield put({
                    type: 'MEDALS/FETCH_FAILED',
                    result
                });
            }
        } catch (e) {
            yield put({
                type: 'MEDALS/FETCH_FAILED',
                e
            });
        }
    });
}

//MEDALS/FETCH/FULL
export function* getMedalsFull() {
    yield* takeEvery("MEDALS/FETCH/FULL", function* (action) {
        try {
            const result = yield call(({ id }) => {
                return request.get(`${config.apiEndpoint}/api/cs/v2/medals${id ? `/${id}` : '/full'}`)
                    .set('Authorization', `Bearer ${config.apiKey}`)
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { medals, medal } = result;
                if (action.id) {
                    yield put({ type: 'MEDAL/SET', medal });
                } else {
                    localStorage.setItem('CS.MEDALS', JSON.stringify(medals));
                    yield put({ type: 'MEDALS/SET', medals });
                }
            } else {
                yield put({
                    type: 'MEDALS/FETCH_FAILED',
                    result
                });
            }
        } catch (e) {
            yield put({
                type: 'MEDALS/FETCH_FAILED',
                e
            });
        }
    });
}


// WEBPACK FOOTER //
// ./src/redux-sagas/sagas/medals.js